// extracted by mini-css-extract-plugin
export default {"mainContainer":"OurValuesTxt_mainContainer__JPoJn","redLine":"OurValuesTxt_redLine__hL9Bw","heading":"OurValuesTxt_heading__xkbR9","valueWrapper":"OurValuesTxt_valueWrapper__uD0uZ"};